import React, { useState } from 'react'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useQuery } from 'react-query'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
//import './UserCss.css'

function ViewUser() {
    const history = useHistory();
    const { usercode } = useParams()
    const [APIUrl, setAPIUrl] = useState('/api/profile/get/userdetails/' + usercode)
    const { data: user, isLoading } = useQuery('listUsers', () => Fetcher('get', APIUrl, {}))
    function editUser() {
        // history.push('/admin/user/edit/' + usercode);
        window.location.href = '/' + localStorage.getItem("role") + '/edit/' + usercode
    }
    function editUserEdu() {
        window.location.href = '/' + localStorage.getItem("role") + '/auditordetails/' + usercode
    }
    console.log("user", user)
    if (isLoading) return <h1>Loading</h1>

    return (
        <div className="content-wrapper" >
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        {/* <div className="col-lg-3">
                    <img src="../../assets/img/profileImg.png" className="rounded float-left dummyUserImg" />
            </div> */}

                        <div className="col-sm-12" style={{ minHeight: "450px" }}>
                            <div className="card-body" style={{ paddingLeft: "4rem", paddingTop: "1rem", paddingRight: "6rem" }}>
                                <div className="row">
                                    <div className="col-sm-12" >
                                        <div className="row">

                                            <div className="col-lg-2">
                                                <strong> Name </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.fullName}
                                            </div>
                                            <div className="col-lg-2">
                                                <strong>Email ID    </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.emailId}
                                            </div>
                                        </div>
                                        <br></br>

                                        <div className="row mt-4">

                                            <div className="col-sm-2">
                                                <strong>Mobile   </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.mobNum || "-"}
                                            </div>
                                            <div className="col-sm-2">
                                                <strong>Designation   </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.designation || "-"}
                                            </div>
                                        </div>

                                        <div className="row mt-4">

                                            <div className="col-sm-2">
                                                <strong>Password   </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.password}
                                            </div>

                                        </div>


                                        <br />
                                        <div className="row mt-4">

                                            <div className="col-sm-2">
                                                <strong>Role   </strong>
                                            </div>
                                            <div className="col-sm-4">
                                                {user.data.response.role || "-"}
                                            </div>

                                            {
                                                user.data.response.role === "Executive(Support)" ?

                                                    <>
                                                        <div className="col-sm-2">
                                                            <strong>Manager Name   </strong>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            {user.data.response.manager || "-"}
                                                        </div>
                                                    </>
                                                    :
                                                    ""
                                            }
                                        </div>
                                        {
                                            user.data.response.role === "Lead Auditor" || user.data.response.role === "Asst Auditor" || user.data.response.role === "Auditor" ?
                                                <div>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-2">
                                                            <strong> Educational Qualifications  </strong>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            {user.data.response.eduqualification || "-"}
                                                        </div>
                                                        <div className="col-sm-2">
                                                            <strong>Total work Experience  </strong>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            {user.data.response.totalWorkExp  || "-"}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">
                                                        <div className="col-sm-2">
                                                            <strong> Lead Audit Training </strong>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            {user.data.response.leadAuditTraining || "-"}
                                                        </div>
                                                        <div className="col-sm-2">
                                                            <strong>Audit Experience  </strong>
                                                        </div>
                                                        <div className="col-sm-4">
                                                            {user.data.response.auditExperience || "-"}
                                                        </div>
                                                    </div>
                                                    <div className="row mt-4">

                                                        <div className="card-body table-responsive">
                                                            <table className="table table-bordered " >
                                                                <thead className="table-primary">
                                                                    <tr>
                                                                        <th scope="col" className="text-center">#</th>
                                                                        <th scope="col" className="text-center">ANZ-SIC CODE</th>
                                                                        <th scope="col" className="text-center">Exp</th>
                                                                        <th scope="col" className="text-center">Auditor Training</th>
                                                                        <th scope="col" className="text-center">Audit Logs</th>
                                                                        <th scope="col" className="text-center">Examination </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody >
                                                                    {
                                                                        user.data.response && user.data.response.auditorDetails && user.data.response.auditorDetails.length && user.data.response.auditorDetails.length > 0 ?
                                                                            user.data.response.auditorDetails.map((item, index) => {


                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td className="text-center">{index + 1}.</td>
                                                                                        <td>{item.anzsicName}</td>
                                                                                        <td>{item.expYesno}</td>
                                                                                        <td>{item.auditorTrainingYesno}</td>
                                                                                       
                                                                                     
                                                                                     
                                                                                        <td>{item.auditlogsYesno}</td>
                                                                                        <td className="text-center">{item.examinationYesno}</td>

                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            <>No Process Details have been added yet </>
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>


                                                : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {user.data.response.role === "Lead Auditor" || user.data.response.role === "Asst Auditor" || user.data.response.role === "Auditor" ?
 
            <div className="card-footer">
                <div className="row">
                    <div className="col-sm-8"></div>
                    <div className="col-sm-2">
                        <button type="button" className="btn btn-primary float-right" onClick={() => editUserEdu()}>Edit Education </button>
                    </div>
                    <div className="col-sm-2">
                        <button type="button" className="btn btn-primary float-right" onClick={() => editUser()}>Edit</button>
                    </div>
                </div>
            </div>
            :
              <div className="card-footer">
                <div className="row">
                    <div className="col-sm-10"></div>
                    <div className="col-sm-2">
                        <button type="button" className="btn btn-primary float-right" onClick={() => editUser()}>Edit</button>
                    </div>
                    
                </div>
            </div>
            }
        </div>
    )
}

export default ViewUser
